import { Component } from '@angular/core';

@Component({
    selector: 'can-guidic',
    template: require('./can-guidic.component.html'),
})

export class CanGuidicComponent {    

    constructor() {
    
    }

    navigateURL(url: string) {
        window.open(url, '_blank');
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/projects/can_guidic/can-guidic.component.ts
 **/